import React from "react";

const TextInput = (props) => {
  const style =
    "w-full block px-2 py-2 border rounded-md text-base bg-slate-200 mb-4 focus:shadow-buttonFocus focus:border-blackrock";

  return (
    <React.Fragment>
      <label className="block" htmlFor={props.for}>
        {/* {props.label} */}
      </label>
      <input
        id={props.for}
        className={!props.isError ? style : style}
        type={props.type}
        name={props.for}
        value={props.value}
        placeholder="Enter password"
        onChange={(e) => {
          props.onChange(e);
        }}
      />
      {props.isError && (
        <span className="block text-sm text-accent mt-1 mb-4 ">
          Incorrect password
        </span>
      )}
    </React.Fragment>
  );
};

export default TextInput;
